export default __webpack_public_path__ + "9a159b23b9ef7ec0717a7a2a0d6e3ee1.svg";